// removed by extract-text-webpack-plugin
module.exports = {"root":"_3vmsH8MHezqtJPP2saSVng"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/translate.scss
// module id = 1204
// module chunks = 0